import React from 'react';
import Stylesheet from './Heading.module.css';

const Heading = (props) => {
    let overlay = <div className={Stylesheet.Overlay}>
    {props.children}</div>
    switch (props?.index) {
        case 2:
            return <h2 className={Stylesheet.Heading}>
                {overlay}<span>{props.children}</span></h2>
        case 3:
            return <h3 className={Stylesheet.Heading}>
                {overlay}<span>{props.children}</span></h3>
        case 4:
            return <h4 className={Stylesheet.Heading}>
                {overlay}<span>{props.children}</span></h4>
        case 5:
            return <h5 className={Stylesheet.Heading}>
                {overlay}<span>{props.children}</span></h5>
        case 6:
            return <h6 className={Stylesheet.Heading}>
                {overlay}<span>{props.children}</span></h6>
        default:
            return <h1 className={Stylesheet.Heading}>
                {overlay}<span>{props.children}</span></h1>
    }
}

export default Heading;